import Sidebar from "../components/Sidebar";
import React from "react";
import {useNavigate} from "react-router-dom";

function NotFound() {
    const navigate = useNavigate();
    localStorage.removeItem("focus");
    return (
        <>
            <Sidebar/>
            <main className="ml-64 p-6">
                {/* Center this in the page*/}
                <div className="flex flex-col items-center justify-center h-full">
                    <span className="text-6xl font-bold text-blue-600">404</span>
                    <p className="text-xl text-gray-600 mt-4">Pagina non trovata</p>
                    <button
                        className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition mt-4"
                        onClick={() => {
                            navigate("/order")
                        }}>
                        <span>Torna agli ordini</span>
                    </button>
                </div>
                {/*Redirect button to orders*/}

            </main>
        </>
    )
}

export default NotFound;